module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iterators.js
// module id = 61
// module chunks = 0